import { render, staticRenderFns } from "./AttendanceTimelineDrawer.vue?vue&type=template&id=54b85017&scoped=true"
import script from "./AttendanceTimelineDrawer.vue?vue&type=script&lang=js"
export * from "./AttendanceTimelineDrawer.vue?vue&type=script&lang=js"
import style0 from "./AttendanceTimelineDrawer.vue?vue&type=style&index=0&id=54b85017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b85017",
  null
  
)

export default component.exports